import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClienteListInput, ClienteOutput } from 'src/app/@shared/models/cliente.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  constructor(private http: HttpClient) { }

  list(filter?: ClienteListInput): Observable<ClienteOutput[]> {
    return this.http.get<ClienteOutput[]>(`Cliente/list?${filter?.paginaAtual ? `paginaAtual=${filter?.paginaAtual}&` : ""}itensPorPagina=${filter?.itensPorPagina ? `itensPorPagina=${filter?.itensPorPagina}` : ""}`, httpOptions);
  }

  listWithGroup(codigoGrupo?: any): Observable<any[]> {
    return this.http.get<any[]>(`Cliente/ConsultaClientePorGrupo/${codigoGrupo}`, httpOptions);
  }

  getAllClientes(req?: any): Observable<HttpResponse<ClienteOutput[]>> {
    return this.http
      .get<ClienteOutput[]>(
        `Cliente? ${req.nome ? `&nome=${req.nome}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${req.paginaAtual}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  exportarExcel(data: any): Observable<any> {
    return this.http.post('PedidoNRT/ExportarExcel', data, httpOptions) as Observable<any>;
  }

  getClientsList(): Observable<any> {
    return this.http.get<any>('IntegradorCliente/Get', httpOptions);
  }

  obterPesquisaClientePorNome(nome: string): Observable<ClienteOutput[]> {
    return this.http.get<ClienteOutput[]>(`Cliente/PesquisaClientePorNome/${nome}`, httpOptions);
  }
}

export class ClientListRequest {
  Nome?: string;
  ClienteId?: number;
  Ativo?: boolean;
}
